import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { $localize } from '@angular/localize/init';

interface SemaphoreObject {
  type?: string;
  text?: string;
}

@Component({
  selector: 'bn-account-details-loans',
  templateUrl: './account-details-loans.component.html',
})
export class BnAccountDetailsLoansComponent implements OnInit {
  @Input() product: any = {};
  @Input() productNumberFormat: any = {};
  @Input() hostRef: any = {};
  semaphore: SemaphoreObject = {};


  overdueTooltipText: string;
  successTooltipText: string;
  greyTooltipText: string;

  title1: string;
  title2: string;
  title3: string;
  title4: string;
  // overdueTooltipText = $localize`:@@product-details.overdueLabel:Statement payment overdue`;
  // successTooltipText = $localize`:@@product-details.paidLabel:Paid`;
  // greyTooltipText = $localize`:@@product-details.greyLabel:Statement payment pending`;

  // title1 = $localize`:@@product-details.h2.accountDetails:Account Detail`;
  // title2 = $localize`:@@product-details.h2.installmentInfo:Installment information`;
  // title3 = $localize`:@@product-details.h2.overduePayments:Overdue payments`;
  // title4 = $localize`:@@product-details.h2.otherInfo:Other information`;

  constructor(@Inject(LOCALE_ID) private readonly locale: string) {
    this.overdueTooltipText = this.translateString('Statement payment overdue', 'Statement payment overdue');
    this.successTooltipText = this.translateString('Paid', 'Paid');
    this.greyTooltipText = this.translateString('Statement payment pending', 'Statement payment pending');

    this.title1 = this.translateString( 'Detalles de la Cuenta','Account Detail');
    this.title2 = this.translateString('Información de Cuotas','Installment information');
    this.title3 = this.translateString('Pagos vencidos','Overdue payments');
    this.title4 = this.translateString('Más información','Other information');
  }

  translateString(es: string, en: string) {
    return this.locale === 'es-DO' ? es : en;
  }
  
  ngOnInit(): void {
    this.product?.additions?.minimumPmtSemaphoreDOP?.toLowerCase();
    this.semaphore = this.setTooltips(this.product?.additions?.semaphore?.toLowerCase());
  }

  setTooltips(semaphoreValue: string): SemaphoreObject {
    switch (semaphoreValue) {
      case 'green':
        return {
          type: 'success',
          text: this.successTooltipText,
        };
      case 'red':
        return {
          type: 'danger',
          text: this.overdueTooltipText,
        };
      case 'gray':
        return {
          type: 'grey',
          text: this.greyTooltipText,
        };
      default:
        return {};
    }
  }
}
